<template>
  <div class="columns is-mobile">
    <div class="column is-narrow-tablet v-center-column">
      <filter-selector :selectedTypes="selectedTypes" :selectedCategories="selectedCategories" @ok="setSelectedFilters">
      </filter-selector>
    </div>
    <div class="column is-hidden-mobile v-center-column">
      <div class="tags">
        <span v-for="(typeId, index) in selectedTypes" :key="typeId" class="tag is-info">
          {{$t(typeId)}}
          <button class="delete is-small" @click="removeTypeFilter(index)"></button>
        </span>
        <span v-for="(cat, index) in selectedCategories" :key="cat" class="tag is-info">
          {{cat}}
          <button class="delete is-small" @click="removeCategoryFilter(index)"></button>
        </span>
      </div>
    </div>
    <!-- TODO need to decide where to put this if mobile. Adding
         another div around this component causes the margin-bottom of the columns
         to be 0 because it's not the last child anymore
         -->
    <div class="column is-narrow v-center-column">
      <div class="field">
        <b-switch
          v-model="mode"
          true-value="tiles"
          false-value="table"
          type="is-info"></b-switch>
      </div>
    </div>
  </div>
</template>

<i18n src="../../i18n/foodItem-types.i18n.json"></i18n>

<script>
import { mapGetters, mapMutations } from 'vuex';
import FilterSelector from '@/components/FilterSelector';
import i18nMixin from '@/mixins/i18n';
import Types from '../../foodItem-types';

export default {
  name: 'browse-toolbar',
  mixins: [i18nMixin],
  data() {
    return {

    };
  },
  methods: {
    ...mapMutations('browse', {
      setSelectedCategories: 'categories',
      setSelectedTypes: 'types',
      setBrowseMode: 'mode',
    }),
    setSelectedFilters(types, categories) {
      this.setSelectedCategories(categories);
      this.setSelectedTypes(types);
    },
    removeTypeFilter(typeIndex) {
      this.setSelectedTypes(this.selectedTypes
        .filter((type, index) => index !== typeIndex));
    },
    removeCategoryFilter(catIndex) {
      this.setSelectedCategories(this.selectedCategories
        .filter((cat, index) => index !== catIndex));
    },
  },
  computed: {
    ...mapGetters('browse', {
      selectedTypes: 'types',
      selectedCategories: 'categories',
      browseMode: 'mode',
    }),
    types() {
      return Types;
    },
    mode: {
      get() {
        return this.browseMode;
      },
      set(val) {
        this.setBrowseMode(val);
      },
    },
  },
  components: {
    FilterSelector,
  },
};
</script>

<style lang="sass">
.v-center-column
  display: flex
  align-items: center
</style>

 


// WEBPACK FOOTER //
// src/components/browse/BrowseToolbar.vue